// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Category } from "./category";
import { Interface } from "./interface";

/**
 * A wire key: the interface, the section, and the two ids.
 */
export class Key implements flatbuffers.IUnpackableObject<KeyT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Key {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  iface(): Interface {
    return this.bb!.readUint8(this.bb_pos);
  }

  category(): Category {
    return this.bb!.readUint8(this.bb_pos + 1);
  }

  id(): number {
    return this.bb!.readUint32(this.bb_pos + 4);
  }

  subId(): number {
    return this.bb!.readUint32(this.bb_pos + 8);
  }

  static sizeOf(): number {
    return 12;
  }

  static createKey(
    builder: flatbuffers.Builder,
    iface: Interface,
    category: Category,
    id: number,
    sub_id: number,
  ): flatbuffers.Offset {
    builder.prep(4, 12);
    builder.writeInt32(sub_id);
    builder.writeInt32(id);
    builder.pad(2);
    builder.writeInt8(category);
    builder.writeInt8(iface);
    return builder.offset();
  }

  unpack(): KeyT {
    return new KeyT(this.iface(), this.category(), this.id(), this.subId());
  }

  unpackTo(_o: KeyT): void {
    _o.iface = this.iface();
    _o.category = this.category();
    _o.id = this.id();
    _o.subId = this.subId();
  }
}

export class KeyT implements flatbuffers.IGeneratedObject {
  constructor(
    public iface: Interface = Interface.Dispatcher,
    public category: Category = Category.Parameter,
    public id: number = 0,
    public subId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return Key.createKey(builder, this.iface, this.category, this.id, this.subId);
  }

  clone(): KeyT {
    const obj = new KeyT();
    obj.iface = this.iface;
    obj.category = this.category;
    obj.id = this.id;
    obj.subId = this.subId;
    return obj;
  }

  equals(other: KeyT): boolean {
    if (this.iface !== other.iface) return false;
    if (this.category !== other.category) return false;
    if (this.id !== other.id) return false;
    if (this.subId !== other.subId) return false;
    return true;
  }
}
